<template>
  <v-app id="app">
    <router-view />

    <template v-if="envMode && ['dev', 'staging'].includes(envMode)">
      <div id="envWarn">
        Coach <span class="text-capitalize">{{ envMode }}</span>
      </div>
    </template>
  </v-app>
</template>

<script>
export default {
  name: 'App',

  data: () => ({}),

  computed: {
    envMode() {
      return process.env.VUE_APP_ENV || null;
    },
  },
};
</script>

<style>
  * {
    word-break: break-word !important;
  }

  body {
    background-color: #121212;
  }

  #envWarn {
    position: fixed;
    top: 0;
    left: 50%;
    color: white;
    border-radius: 5px;
    z-index: 99999;
    padding: 5px 10px;
    font-weight: bold;
    margin-top: 13px;
    transform: translateX(-50%);
    animation: warning 2s ease-in-out infinite;
  }

  @keyframes warning {
    0% {background: red; box-shadow: 0 0 10px 5px rgba(255, 0, 0, 0.5);}
    25% {background: blue; box-shadow: 0 0 10px 5px rgba(100, 100, 255, 0.5);}
    100% {background: red; box-shadow: 0 0 10px 5px rgba(255, 50, 50, 0.7);}
  }
</style>
